import Chip from '@mui/material/Chip';
import { VerificationStatusDto, CompanyScoringState, ReportSnapshotDto } from 'models/dtoTypes';
import { useTranslation } from 'react-i18next';

export default function VerificationStatusChip({
  verificationStatus,
  isDissolved,
  scoringState,
}: {
  verificationStatus?: VerificationStatusDto;
  isDissolved?: boolean;
  scoringState?: CompanyScoringState;
  reportSnapshot?: ReportSnapshotDto;
}) {
  const { t } = useTranslation('default');

  if (isDissolved) {
    return <Chip label="Dissolved" color="error" />;
  }

  const lowerStatus = verificationStatus?.toString()?.toLowerCase() || '';

  switch (lowerStatus) {
    case 'pending':
      return <Chip label={t('pending')} color="warning" />;
    case 'notfound':
      return <Chip label={t('not-found')} color="info" />;
    case 'verifyerror':
      return <Chip label={t('error')} color="error" />;
    case 'dissolved':
      return <Chip label={t('dissolved')} color="error" />;
    case 'multipleresults':
      return <Chip label={t('multiple-results')} color="info" />;
    case 'verified': {
      switch (scoringState) {
        case 'NotStarted':
          return <Chip label={t('verified')} color="primary" />;
        case 'InProgress':
          return <Chip label={t('in-progress')} color="info" />;
        case 'Error':
          return <Chip label={t('score-error')} color="error" />;
        case 'Completed':
          return <Chip label={t('complete')} color="success" />;
        default:
          return <Chip label={t('verified')} color="primary" />;
      }
    }
    default:
      return <></>;
  }
}
